'use strict';

import storage from './../storage';

let tireSizes = {
  el: document.querySelector('.tire-sizes'),
  itemsShownByDefault: 3,

  init: function () {
    const self = this;

    if (this.el) {
      console.log('tireSizes.init()');

      // Product item groups
      const groupsContainer = document.querySelector('.js-tire-sizes-groups');
      const groupButtons = groupsContainer?.querySelectorAll('.js-tire-sizes--toggle-group') || null;
      const groupSelect = groupsContainer?.querySelector('select');
      let initialLoad = true;
      const items = document.querySelectorAll('.js-tire-sizes-list .item') as NodeListOf<HTMLElement> || [];
      const showMoreItemsButton = document.querySelector('.js-tire-sizes--show-more-items');
      const showLessItemsButton = document.querySelector('.js-tire-sizes--show-less-items');


      if (items.length < self.itemsShownByDefault) {
        showMoreItemsButton?.classList.add('hidden');
      }

      // Set active group to group buttons and select
      const setGroup = function (group) {
        // Unselect tabs
        if (groupSelect) groupSelect.value = group;
        if (groupButtons) {
          groupButtons.forEach(el => (el as HTMLElement).dataset.group === group ? el.classList.add('selected') : el.classList.remove('selected'));
        }
      };

      // Show items in group
      const showGroupItems = function (group, width?, height?) {
        if (group === 'all') {
          items.forEach(el => el.classList.remove('hidden'));
        } else {
          items.forEach((item) => {
            const itemGroup = String(item.dataset.group);

            if (width && height) {
              const itemWidth = String(item.dataset.width);
              const itemHeight = String(item.dataset.height);
              width = String(width);
              height = String(height);

              // TODO: Check this
              //item.toggleClass('hidden', (itemGroup === group && itemWidth === width && itemHeight === height ? false : true));
              if (itemGroup === group && itemWidth === width && itemHeight === height) {
                item.classList.remove('hidden');
              } else {
                item.classList.add('hidden');
              }
            } else {
              //item.toggleClass('hidden', (itemGroup === group ? false : true));
              if (itemGroup === group) {
                item.classList.remove('hidden');
              } else {
                item.classList.add('hidden');
              }
            }
          });

        }

        showMoreItemsButton?.classList.add('hidden');
        showLessItemsButton?.classList.add('hidden');

        if (group === 'all' || Array.from(items).filter(el => el.dataset.group === group).length > self.itemsShownByDefault) {
          showLessItemsButton?.classList.remove('hidden');
        }
      };

      // Reduce shown items in group (show few, hide rest)
      const showLessItems = function (group) {
        let itemsWasHidden = false;
        Array.from(items).filter(el => group === 'all' || el.dataset.group === group).forEach((item, index) => {
          if (index >= self.itemsShownByDefault) {
            item.classList.add('hidden');
            itemsWasHidden = true;
          }
        });

        showMoreItemsButton?.classList.add('hidden');
        showLessItemsButton?.classList.add('hidden');

        if (itemsWasHidden) {
          showMoreItemsButton?.classList.remove('hidden');

          // Scroll to tire sizes element top
          var offsetTop = (self.el as HTMLElement)?.offsetTop;
          if(window.scrollY > offsetTop){
            window.scrollTo({
              top: offsetTop,
              left: 0,
              behavior: "smooth",
            });
          }
        }
      };

      groupSelect?.addEventListener('change', function (e) {
        const group = String(this.value);

        setGroup(group);
        showGroupItems(group);
      });

      groupButtons?.forEach(el => el.addEventListener('click', function (e) {
        const el = e.target as HTMLElement;
        const group = String(el.dataset.group);

        setGroup(group);
        showGroupItems(group);
      })
      );



      // Show all items from active group
      showMoreItemsButton?.addEventListener('click', function (e) {
        const selectedGroup: HTMLElement | null = groupsContainer?.querySelector('li button.selected') || null;
        const group = selectedGroup?.dataset.group ? selectedGroup.dataset.group : 'all';

        showGroupItems(group);
      });

      // Hide all items from active group
      showLessItemsButton?.addEventListener('click', function (e) {
        const selectedGroup: HTMLElement | null = groupsContainer?.querySelector('li button.selected') || null;
        const group = selectedGroup?.dataset.group ? selectedGroup.dataset.group : 'all';

        showLessItems(group);
        setGroup(group);
      });

      // "Click" selected groupButton
      const initialGroup: HTMLElement | null = groupsContainer?.querySelector('li button.selected') || null;

      let selectedGroup = initialGroup?.dataset.group ? initialGroup.dataset.group : 'all';
      let selectedWidth;
      let selectedHeight;

      // Get selected group by cookieObj if exists
      // do we have HTML5 storage support?
      if (storage.session) {
        let tyreDataFromSession = sessionStorage.getItem('tyreData') || localStorage.getItem('tyreData');

        try {
          if (tyreDataFromSession) {
            let tyreData: {width: number; height: number; rim: number} = JSON.parse(tyreDataFromSession);

            // Set selected group by rim, if button exists
            if (tyreData && tyreData.width && tyreData.height && tyreData.rim) {

              selectedGroup = (groupsContainer?.querySelector('li button[data-group="' + tyreData.rim + '"]') as HTMLElement).dataset.group || 'all';
              selectedWidth = tyreData.width;
              selectedHeight = tyreData.height;
            }
          }
        } catch (e) {
          //
        }
      }

      if (selectedGroup && selectedGroup !== 'all') {
        setGroup(selectedGroup);
        showGroupItems(selectedGroup, selectedWidth, selectedHeight); // show group with certain size only by default
      }

      // If url has a product code, highlight it in tires list, show eu label and scroll it in view
      window.addEventListener('load', () => {
        const productCode = window.location.search.match('productCode=([A-Z0-9]+)(?:&|$)');
        const item = productCode ? this.el?.querySelector('.item[data-code="' + productCode[1] + '"]') : false;
        const toggle = productCode ? this.el?.querySelector('#tire-size--toggle-more--' + productCode[1]) : false;

        if (item) {
          setGroup('all');
          showGroupItems('all');

          item.classList.add('highlight');
          if (toggle) {
            toggle[0].checked = true;
          }

          item[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }

        // If initial load and no groups container, show all items
        if (initialLoad && !groupsContainer) {
          initialLoad = false;
          setGroup('all');
          showGroupItems('all');
          showLessItems('all');
        }

      });
    }
  },
};

export default tireSizes;
